document.addEventListener("DOMContentLoaded", function () {
  let popupShown = false;

  const PERFILADOR_KEY = "popup_perfilador";
  const PERFILADOR_COOLDOWN = 15 * 60 * 1000; // 15 min

  const ABANDON_COOLDOWN = 180 * 60 * 1000; // 180 min

  function perfiladorBloqueaPopup() {
    try {
      const raw = localStorage.getItem(PERFILADOR_KEY);
      if (!raw) return false; // no existe => no bloquea
      const ts = Number(raw);
      if (!Number.isFinite(ts)) return false; // valor inválido => no bloquea
      return Date.now() - ts < PERFILADOR_COOLDOWN; // true => bloquear
    } catch (e) {
      return false; // por seguridad, no bloquear si algo falla leyendo LS
    }
  }

  const MKT_PREFIX = "last_visited_clip_mkt2025_";
  const MKT_COOLDOWN = 5 * 60 * 1000; // 5 min

  function hayPopupMarketingReciente() {
    const ahora = Date.now();
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || !key.startsWith(MKT_PREFIX)) continue;
      const iso = localStorage.getItem(key);
      const ts = Date.parse(iso);
      if (!Number.isNaN(ts) && ahora - ts < MKT_COOLDOWN) {
        return true; // hay huella reciente → bloquear
      }
    }
    return false; // no hay huellas recientes → no bloquear
  }

  function hasHandleInCart(targetHandle, callback) {
    fetch("/cart.js")
      .then((r) => r.json())
      .then((data) => {
        const items = Array.isArray(data.items) ? data.items : [];
        const found = items.some((item) => {
          // 1) Método robusto: extraer handle desde la URL del ítem
          if (item.url) {
            try {
              const path = new URL(item.url, location.origin).pathname; // soporta absoluta o relativa
              const after = path.split("/products/")[1] || "";
              const handleFromUrl = after.split("/")[0];
              if (handleFromUrl === targetHandle) return true;
            } catch (e) {
              // fallback simple si URL() falla
              if (item.url.indexOf(`/products/${targetHandle}`) !== -1) return true;
            }
          }
          // 2) Algunos temas incluyen item.handle en /cart.js
          if (item.handle && item.handle === targetHandle) return true;

          return false;
        });
        callback(found);
      })
      .catch((err) => {
        console.error("Error leyendo /cart.js:", err);
        callback(false);
      });
  }

  // Helper: parsea el lastShown de forma segura (PUNTO 1)
  function getLastShownMs() {
    const raw = localStorage.getItem("cart_abandon_popup");
    const ts = Number(raw);
    return Number.isFinite(ts) ? ts : null;
  }

  function showPopup() {
    if (perfiladorBloqueaPopup()) return;
    if (hayPopupMarketingReciente()) return;

    const now = Date.now();
    const lastShownMs = getLastShownMs();

    // Si ya se mostró (en esta carga) o sigue en cooldown, salir rápido
    if (popupShown) return;
    if (lastShownMs !== null && now - lastShownMs <= ABANDON_COOLDOWN) return;

    // Solo mostrar si está el handle objetivo en el carrito
    hasHandleInCart("clip-plus-2", (hasTarget) => {
      // PUNTO 2: re-chequeo dentro del callback (por triggers múltiples / fetches pendientes)
      const now2 = Date.now();
      const lastShownMs2 = getLastShownMs();

      if (!hasTarget) return;
      if (popupShown) return;
      if (lastShownMs2 !== null && now2 - lastShownMs2 <= ABANDON_COOLDOWN) return;

      popupShown = true;
      localStorage.setItem("cart_abandon_popup", String(now2));

      document.body.style.overflow = "hidden";
      const popup = document.getElementById("popup-canva-abandoned");
      if (popup) popup.style.display = "flex";

      const el = document.getElementById("ab_contador");
      if (el) el.style.display = "flex";
      startAbCountdown();
    });
  }

  // cuando el usuario sube con el puntero (desktop exit intent)
  document.addEventListener("mouseleave", function (e) {
    if (e.clientY <= 0) showPopup();
  });

  // cuando el usuario cambia de pestaña
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) showPopup();
  });

  // usuario sin tocar la pantalla por x minutos
  let inactivityTimeout;
  function resetInactivityTimer() {
    clearTimeout(inactivityTimeout);
    inactivityTimeout = setTimeout(showPopup, 10 * 60000); // 10 minutos
  }
  document.addEventListener("mousemove", resetInactivityTimer);
  document.addEventListener("touchmove", resetInactivityTimer);
  document.addEventListener("scroll", resetInactivityTimer);
  resetInactivityTimer(); // Iniciar el temporizador

  // En Mobile (cuando el usuario scrollea hacia arriba) - sigue desactivado
  let lastScrollTop = window.scrollY;
  window.addEventListener("scroll", function () {
    let scrollTop = window.scrollY;
    if (scrollTop < lastScrollTop && scrollTop < 100) {
      //showPopup();
    }
    lastScrollTop = scrollTop;
  });

  // Cuando intentan cerrar la pestaña - sigue desactivado
  window.addEventListener("beforeunload", function (e) {
    //showPopup();
    //e.preventDefault();
    //e.returnValue = "¿Estás seguro de que quieres salir?";
  });

  document.getElementById("cerrar-abandoned").addEventListener("click", function () {
    const popup = document.getElementById("popup-canva-abandoned");
    if (popup) popup.style.display = "none";
    document.body.style.overflow = "auto";
    window.scrollTo(0, 0);
  });
});





// ======= Cuenta regresiva “duracion_promo” minutos desde el primer despliegue diario =======
const AB_COOKIE = "abandoned_count";  // guarda el inicio como fecha UTC
const AB_MINUTOS_PROMO = 15;
const AB_MS_PROMO = AB_MINUTOS_PROMO * 60 * 1000;

let abIntervalId = null;

function setCookie(name, value, expiresDate) {
  const exp = expiresDate.toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${exp}; path=/; SameSite=Lax`;
}
function getCookie(name) {
  const prefix = name + "=";
  return document.cookie.split(";").map(c=>c.trim()).reduce((acc,c)=>{
    if (c.indexOf(prefix)===0) acc = decodeURIComponent(c.substring(prefix.length));
    return acc;
  }, "");
}
function deadlineFromCookieOrCreate() {
  const raw = getCookie(AB_COOKIE);
  const nowMs = Date.now();
  const endOfDay = new Date();
  endOfDay.setHours(23, 59, 59, 999);

  if (raw) {
    const t = Date.parse(raw);
    if (!Number.isNaN(t)) {
      const dl = t + AB_MS_PROMO;   // deadline calculado desde el primer inicio
      if (dl > nowMs) return dl;    // aún vigente → úsalo
      // 🔁 vencido → reiniciar ventana de 15 min desde ahora
      setCookie(AB_COOKIE, new Date(nowMs).toUTCString(), endOfDay);
      return nowMs + AB_MS_PROMO;
    }
  }
  // No existía cookie → crear inicio ahora
  setCookie(AB_COOKIE, new Date(nowMs).toUTCString(), endOfDay);
  return nowMs + AB_MS_PROMO;
}

function startAbCountdown() {
  // Evita múltiples intervalos si el popup se reabre
  if (abIntervalId) return;

  const $cont = document.getElementById("ab_contador");
  const $mm = document.getElementById("ab_minutos");
  const $ss = document.getElementById("ab_segundos");
  if (!$cont || !$mm || !$ss) return;

  const deadline = deadlineFromCookieOrCreate();

  function tick() {
    const now = Date.now();
    const remaining = deadline - now;

    if (remaining <= 0) {
      clearInterval(abIntervalId);
      abIntervalId = null;
      $cont.style.display = "none";
      return;
    }

    // Mostrar mientras haya tiempo
    if ($cont.style.display === "none") $cont.style.display = "flex";

    const mins = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
    const secs = Math.floor((remaining % (1000 * 60)) / 1000);

    $mm.textContent = String(mins).padStart(2, "0");
    $ss.textContent = String(secs).padStart(2, "0");
  }

  tick(); // primer pintado inmediato
  abIntervalId = setInterval(tick, 1000);
}